import { render, staticRenderFns } from "./WikiContentFolder.vue?vue&type=template&id=68c29dca"
import script from "./WikiContentFolder.vue?vue&type=script&lang=js"
export * from "./WikiContentFolder.vue?vue&type=script&lang=js"
import style0 from "./WikiContentFolder.vue?vue&type=style&index=0&id=68c29dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports